import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrl: './datepicker.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class DatepickerComponent implements OnInit {
    @Output() dateChange = new EventEmitter();
    @Input() isRange: boolean = false;
    @Input() iconPosition: string = 'left';
    @Input() form!: FormGroup;

    ngOnInit(): void {
        if (this.isRange) {
            this.form.addControl('startDate', new FormControl(null));
            this.form.addControl('endDate', new FormControl(null));
        } else {
            this.form.addControl('date', new FormControl(null));
        }
    }

    onDateChange(): void {
        this.dateChange.emit(this.form.value);
    }
}
